import L from "leaflet";

const MarkerIcon = (
  type,
  color = [],
  isSelected = false,
  cluster,
  isCluster = false,
  selectedInstitution,
  innerIcon = "",
  entity
) => {
  //--- Allow to set an active state (change cluster Icon color) to the cluster via isInCluster
  if (isCluster) {
    let isInCluster = false;
    const clusterChildMarkers = cluster.getAllChildMarkers();
    if (selectedInstitution) {
      for (const clusterChildMarker of clusterChildMarkers) {
        if (clusterChildMarker.options.calc.id === selectedInstitution.id) {
          isInCluster = true;
          //cluster.spiderfy();
        }
      }
    }

    return L.divIcon({
      //--- Cluster icon
      html: `<svg class="cluster-icon" version="1.1" id="PUCE-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 32 38" width="32" height="38" style="enable-background:new 0 0 32 38;" xml:space="preserve">
            <path fill=${
              isInCluster ? "var(--wphf-primary)" : "#434341"
            } id="gauche" d="M16,1.2C7.7,1.3,1,8.1,1,16.4c0,6,3.4,11.2,8.5,13.7h0c2.4,1.2,4.7,3.4,6.5,6.7V1.2z"/>
            <path fill=${
              isInCluster ? "var(--wphf-primary)" : "#434341"
            } id="droite" d="M16.1,1.2C16,1.2,16,1.2,16.1,1.2L16,36.8c0,0,0,0.1,0.1,0.1c1.9-3.4,4.1-5.6,6.6-6.8h0
                c5-2.5,8.5-7.7,8.5-13.7C31.1,8,24.4,1.2,16.1,1.2z"/>
            </svg>
            <div class="cluster-icon__child-count">${cluster.getChildCount()}</div>
            `,
      iconSize: L.point(33, 33, true),
      className: "custom-marker-cluster",
    });
  } else {
    //--- One color marker
    const icon1 = L.divIcon({
      className: `my-custom-pin ${isSelected ? "active" : ""}`,
      iconAnchor: [15, 30],
      labelAnchor: [-6, 0],
      popupAnchor: [0, -36],
      iconSize: [30, 30],
      html: `<svg class="${
        isSelected ? "active" : ""
      } " version="1.1" id="PUCE-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 32 38" width="32" height="38" style="enable-background:new 0 0 32 38;" xml:space="preserve">
                <path fill="#c940bb" id="gauche" d="M16,1.2C7.7,1.3,1,8.1,1,16.4c0,6,3.4,11.2,8.5,13.7h0c2.4,1.2,4.7,3.4,6.5,6.7V1.2z"/>
                <path fill="#c940bb" id="droite" d="M16.1,1.2C16,1.2,16,1.2,16.1,1.2L16,36.8c0,0,0,0.1,0.1,0.1c1.9-3.4,4.1-5.6,6.6-6.8h0
                    c5-2.5,8.5-7.7,8.5-13.7C31.1,8,24.4,1.2,16.1,1.2z"/>
                <circle fill="#FFFFFF" fill="" id="centre" cx="16" cy="16.3" r="5.8"/>
                </svg>
                `,
    });
    return icon1;
  }
};

export default MarkerIcon;
